require('./removeBeneficiary.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');
const { ContentBox } = require('commonsComponents/contentBox');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { formatIbanString } = require('commonsUtilities/stringHelper');
const { REMOVE_BENEFICIARY_ID } = require('constants/operationTypes');
const { HYPHEN } = require('constants/index');
const WizardError = require('components/commons/wizardError/wizardError');
const RemoveBeneficiarySuccess = require('components/transfers/transfersAgenda/removeBeneficiary/removeBeneficiarySuccess/removeBeneficiarySuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKButton } = require('components/commons/OKButton/OKButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY , CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

class RemoveBeneficiary extends React.Component {
    constructor(props) {
        super(props);
        this.handleRemoveBeneficiaryClick = this.handleRemoveBeneficiaryClick.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancel() {
        this.props.history.push(`/myprofile/transfers/agenda`);
    }

    handleRemoveBeneficiaryClick() {
        const { immBeneficiary, requestRemoveBeneficiary } = this.props;
        const beneficiaryId = immBeneficiary.get('id');
        requestRemoveBeneficiary(beneficiaryId);
    }

    isReady() {
        return false;
    }

    render() {
        const { immBeneficiary, immBeneficiaries } = this.props;

        const contentTitle = formatText('transfersAgenda-securityConfirmationHeader');
        const name = immBeneficiary.get('name') || HYPHEN;

        const nameLabel = formatText('beneficiaryAgendaDetail-name');
        const aliasLabel = formatText('beneficiaryAgendaDetail-alias');
        const currencyLabel = formatText('beneficiaryAgendaDetail-currency');
        const operative = formatText('operatives-removeBeneficiary');

        let accountLabel;
        let account;
        let feedbackScreenClass = 'remove-beneficiary__feedback';

        if ( immBeneficiary.get('iban')) {
            accountLabel = formatText('beneficiaryAgendaDetail-iban');
            account = formatIbanString(immBeneficiary.get('iban'));
        } else {
            accountLabel = formatText('beneficiaryAgendaDetail-account');
            account = immBeneficiary.get('accountNumber');
        }

        let block;

        const operationParams = { optional1: immBeneficiary.get('alias') };

        if (immBeneficiaries.get('removeSuccess')) {
            block = (<RemoveBeneficiarySuccess beneficiaryAlias={immBeneficiary.get('alias')} beneficiaryName={immBeneficiary.get('name')}/>);

        } else if (immBeneficiaries.get('removeError')) {
            const errorMessage = formatText('transfersAgenda-removeBeneficiaryErrorTitle');
            const errorSubMessage = <FormattedText values="transfersAgenda-removeBeneficiaryError" />;
            const goBackButton = {
                label: formatText('transfersAgenda-removeBeneficiarySuccessScreenButton').toUpperCase(),
                url: `/myprofile/transfers/agenda`
            };
            block = <WizardError errorMessage={errorMessage} errorSubMessage={errorSubMessage} mainButton={goBackButton} fullWidthWizardStep={__CONTACT_CENTER__}/>;

        } else {
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

            feedbackScreenClass = "";

            block = (
                <div>
                    <PreLeaveModalComponent
                        acceptText={acceptText}
                        confirmationMessage={confirmationMessage}
                        confirmationTitle={confirmationTitle}
                        cancelText={cancelText}
                        isReady={this.isReady}
                    />
                    <h1 className="remove-beneficiary__title">{contentTitle}</h1>

                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                    </ContactCenterRender>

                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title={nameLabel}
                            bodyText={name}
                        />
                        <OKInformativeListItem
                            title={accountLabel}
                            bodyText={account}
                        />
                        <OKInformativeListItem
                            title={aliasLabel}
                            bodyText={immBeneficiary.get('alias')}
                        />
                        <OKInformativeListItem
                            title={currencyLabel}
                            bodyText={immBeneficiary.get('currency')}
                        />
                    </OKInformativeList>

                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>

                    <SignaturePattern
                        operationType={REMOVE_BENEFICIARY_ID}
                        operationParams={operationParams}
                        customClassName="remove-beneficiary__signature"
                    />
                    <div className="remove-beneficiary__separator"/>
                    <footer className="remove-beneficiary__button text-right">
                        <div className="pull-left">
                            <OKButton modifier="link-ghost" onClick={() => this.handleCancel()}>
                                <FormattedText value="common-cancel" />
                            </OKButton>
                        </div>
                        <SignaturePatternButton
                            onClick={this.handleRemoveBeneficiaryClick}
                            loading={immBeneficiaries.get('isRemoving')}
                        >
                            <FormattedText value="transfersAgenda-removeBeneficiaryAction" />
                        </SignaturePatternButton>
                    </footer>
                </div>
            );
        }

        feedbackScreenClass = (__CONTACT_CENTER__) ? feedbackScreenClass : null;

        return (
            <ContentBox
                id="removeBeneficiary"
                smallTitle="true"
                customClassName={feedbackScreenClass}
            >
                {block}
            </ContentBox>
        );
    }
}

RemoveBeneficiary.propTypes = {
    history: PropTypes.object.isRequired,
    immBeneficiary: PropTypes.object.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    requestRemoveBeneficiary: PropTypes.func.isRequired
};

module.exports = withRouter(RemoveBeneficiary);
